import { render } from "./add-strategy.vue?vue&type=template&id=686b1f00&scoped=true"
import script from "./add-strategy.vue?vue&type=script&lang=js"
export * from "./add-strategy.vue?vue&type=script&lang=js"

import "./add-strategy.vue?vue&type=style&index=0&id=686b1f00&scoped=true&lang=scss"

import exportComponent from "D:\\peizhe_protal\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-686b1f00"]])

export default __exports__